/**
 * Pluralize a word
 * @param {string} singularText - The singular word
 * @param {string} pluralText - The plural word
 * @param {number} count - The number of items
 *
 * Note: This has been borrowed from the `libs/helpers` package in the root of the monorepo
 */
export const plural = (
  singularText: string,
  pluralText: string,
  count: number,
  //  we want plural responses  for 0 & greater than 1
) => (count > 1 || count === 0 ? pluralText : singularText);
